import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl } from '@angular/forms';
import {CommonService} from '../../../../../../core/services/common.service';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';


@Component({
  selector: 'app-select-document-moha-digital',
  templateUrl: './select-document-moha-digital.component.html',
  styleUrls: ['./select-document-moha-digital.component.scss']
})
export class SelectDocumentMohaDigitalComponent implements OnInit {
  searchCtrl: FormControl = new FormControl();
  selectedOption: any;
  checkFocus = false;
  checkDrop = false;
  
  dataTree: any[] = [];
  dataSelect: any[] = [];
  serviceTypes: any[] = [];


  constructor(
    public dialogRef: MatDialogRef<SelectDocumentMohaDigitalComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private documentTypeService: DocumentTypeService,
    public commonService: CommonService
  ) {}

  ngOnInit() {
    this.getServiceTypes();
  }

  getServiceTypes() {
    this.documentTypeService.getServiceTypesMoha(localStorage.getItem('enterpriseId'), true).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return;
      }
      this.serviceTypes = rs.data;
      const filteredData = rs.data.filter((item: any) => item.isEmploymentContract === true);
      
      this.dataTree = filteredData.map((item: any) => ({
        key: item.id,
        title: item.name,    
        originalData: item      
      }))
      
      this.dataSelect = this.dataTree;
    });
  }

  changeData() {
    this.dataSelect = this.dataTree;
  }

  FilterData(event: any) {
    const rawTerm = (event && event.target && event.target.value) ? event.target.value : '';
    const searchTerm = this.normalize(rawTerm);
  
    this.dataSelect = this.dataTree.filter(item =>
      item.title && this.normalize(item.title).includes(searchTerm)
    );
  }
  
  private normalize(value: string): string {
    return (value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }
  
  cancel() {
    this.dialogRef.close();
  }

  submit() {
    if (this.selectedOption) {
      const selectedItem = this.dataTree.find(item => item.key === this.selectedOption);
      this.dialogRef.close({
        data: {
          selectedTypeId: this.selectedOption,
          originalData: selectedItem ? selectedItem.originalData : null
        }
      });
    }
  }
}
